// Copyright (c) 2016 Deere & Company

import newTransferActionCreators from '../../new-transfer/action-creators';
import { resetDealerResults } from './reset-dealer-results';
import { resetSearchParams } from './reset-search-params';
import { updateDealerResults } from './update-dealer-results';
import { updateDivisionParams } from './update-division-params';
import { updateSearchDivisionParam } from './update-search-division-param';
import { updateSearchParams } from './update-search-params';

export default {
    ...newTransferActionCreators,
    resetDealerResults,
    resetSearchParams,
    updateDealerResults,
    updateDivisionParams,
    updateSearchDivisionParam,
    updateSearchParams,
};
